/**
 * Extract a human-readable error message from an axios error.
 *
 * Handles three shapes returned by the FastAPI backend:
 *   1. 400 with a string body:    { detail: "Some message" }
 *   2. 422 Pydantic validation:    { detail: [{ loc: ["body","cin"], msg: "Value error, Invalid CIN format" }, ...] }
 *   3. Anything else (network, 500): a generic fallback.
 */
export function parseApiError(err, fallback = "Request failed") {
  const data = err?.response?.data;
  const detail = data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        // d.loc is like ["body", "cin"] — take the last segment as the field name
        const field = Array.isArray(d.loc) && d.loc.length ? d.loc[d.loc.length - 1] : "";
        // d.msg often starts with "Value error, " — strip it for cleaner display
        const msg = (d.msg || d.message || "Invalid value").replace(/^Value error,\s*/i, "");
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" · ");
  }
  if (data && typeof data === "object" && data.message) return data.message;
  return err?.message || fallback;
}
